import React from 'react';
import PromotionList from 'components/Content/PromotionList/PromotionList';
import { wrapFunctionalComponent } from 'utils/framework';
import PromoListFallback from 'components/Bcc/BccRwdPersonalizedPromoList/PromoListFallback';

const PromotionListTrendingOffersHandler = ({ showFallback, user: { isAnonymous }, ...restProps }) => {
    if (showFallback) {
        return (
            <PromoListFallback
                isSkeleton={restProps.showSkeleton}
                isAnonymous={isAnonymous}
                enablePageRenderTracking={restProps.enablePageRenderTracking}
                sid={restProps.sid}
                title={restProps.title}
                personalization={restProps.personalization}
                extraSotFields={restProps.extraSotFields}
                clientRequestId={restProps.clientRequestId}
            />
        );
    }

    return <PromotionList {...restProps} />;
};

export default wrapFunctionalComponent(PromotionListTrendingOffersHandler, 'PromotionListTrendingOffersHandler');
